import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/photoIcon.png'
import _imports_1 from '@/assets/applet.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "foot" }

import Header from "@/components/header.vue";
  import tail from "@/components/tail.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Header, { idx: 1 }),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"main_left\" data-v-3ebd3d9d><img src=\"" + _imports_0 + "\" alt=\"\" data-v-3ebd3d9d></div><div class=\"main_right\" data-v-3ebd3d9d><div class=\"textBox\" data-v-3ebd3d9d><div class=\"name\" data-v-3ebd3d9d>郊郊按摩</div><div class=\"tipsText\" data-v-3ebd3d9d>足不出户享受<span data-v-3ebd3d9d>五星级按摩服务</span></div><div class=\"text\" data-v-3ebd3d9d>郊郊按摩服务于2022年成立，是国内领先的上门推拿O2O服务平台，提供专业、正规、安全、便捷的24小时上门推拿服务。经过2年的积累，已经拥有了一批忠实稳定的客户，客户群以商旅人士、本地高端消费人士为主，具有很强的消费能力。郊郊按摩服务支持热线电话/微信公众号/小程序等渠道预约方式，足不出户即可享受五星级上门按摩服务。</div><img src=\"" + _imports_1 + "\" class=\"imgBtn\" alt=\"\" data-v-3ebd3d9d></div></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(tail)
      ])
    ])
  ]))
}
}

})